"use client";

import Image from "next/image";
import { usePathname } from "next/navigation";
import { useLocale, useTranslations } from "next-intl";
import React from "react";
import hisaniLogo from "../../../../brand/hisani_logo.png";
import { Link } from "../i18n/navigation";
import { useAuth } from "./auth-client";
import { ProfileAvatar } from "./profile-avatar";

export function PlatformMobileHeader() {
  const auth = useAuth();
  const locale = useLocale();
  const pathname = usePathname();
  const t = useTranslations("Common");
  const tAuth = useTranslations("Auth");
  const normalizedPath = pathname.replace(/\/+$/u, "") || "/";
  const localePrefix = `/${locale}`;
  const platformPath =
    normalizedPath === localePrefix
      ? "/"
      : normalizedPath.startsWith(`${localePrefix}/`)
        ? normalizedPath.slice(localePrefix.length)
        : normalizedPath;
  const isDashboard = platformPath === "/dashboard";
  const isAccount = platformPath === "/account";

  return (
    <header
      data-platform-mobile-header=""
      className="mobile-app-header absolute inset-x-0 top-0 z-[var(--z-index-header)] shrink-0 items-center bg-logo md:hidden"
    >
      <Link
        href={isDashboard ? "/" : "/dashboard"}
        aria-label={t("title")}
        className="inline-flex min-h-11 shrink-0 items-center rounded-xs bg-logo px-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
      >
        <Image
          src={hisaniLogo}
          alt=""
          width={153}
          height={75}
          priority
          className="h-11 w-auto"
        />
      </Link>

      <div className="ms-auto flex items-center gap-2">
        {auth.status === "authenticated" ? (
          isAccount ? null : (
            <Link
              href="/account"
              aria-label={tAuth("account")}
              className="flex size-[44px] items-center justify-center rounded-full transition-colors hover:bg-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-logo"
            >
              <ProfileAvatar
                className="size-8"
                profilePictureUrl={auth.account.profilePictureUrl}
              />
            </Link>
          )
        ) : auth.status === "loading" || auth.status === "unavailable" ? (
          isAccount ? null : (
            <span
              className="size-8 rounded-full bg-subtle"
              aria-hidden="true"
            />
          )
        ) : (
          <Link
            href="/login"
            className="text-body-small inline-flex min-h-11 items-center rounded-md bg-action-primary px-3 font-bold text-action-primary-ink transition-colors hover:bg-action-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-logo"
          >
            {tAuth("signIn")}
          </Link>
        )}
      </div>
    </header>
  );
}
